import { render, staticRenderFns } from "./tishi.vue?vue&type=template&id=4e9dd95c&scoped=true&"
import script from "./tishi.vue?vue&type=script&lang=js&"
export * from "./tishi.vue?vue&type=script&lang=js&"
import style0 from "./tishi.vue?vue&type=style&index=0&id=4e9dd95c&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4e9dd95c",
  null
  
)

export default component.exports